import { PecSwitch } from 'components/route'
import { match, Redirect, Route } from 'react-router'

import { MedicoesPreNatal } from '../../types/model-historicoPreNatal'
import { GraficoAlturaUterinaView } from '../graficos/pre-natal/altura-uterina/GraficoAlturaUterinaView'
import { GraficoGanhoPesoView } from '../graficos/pre-natal/ganho-peso/GraficoGanhoPesoView'
import { MedicaoAntropometricaPreNatal } from './model-medicoesPreNatal'

export interface HistoricoMedicoesPreNatalTabRoutesProps {
  match: match
  medicoesPreNatal: MedicoesPreNatal[]
  dataInicioGestacao: Date
  medicaoForImcReferencia: MedicaoAntropometricaPreNatal
  medicoesPeso10SemanasAposInicioGestacao: MedicaoAntropometricaPreNatal[]
}

export const HistoricoMedicoesPreNatalTabRoutes = (props: HistoricoMedicoesPreNatalTabRoutesProps) => {
  const {
    match,
    medicoesPreNatal,
    dataInicioGestacao,
    medicaoForImcReferencia,
    medicoesPeso10SemanasAposInicioGestacao,
  } = props

  return (
    <PecSwitch>
      <Redirect exact path={match.url} to={`${match.url}/ganho-de-peso`} />
      <Route
        path={`${match.url}/ganho-de-peso`}
        render={() => (
          <GraficoGanhoPesoView
            medicaoForImcReferencia={medicaoForImcReferencia}
            medicoesPeso10SemanasAposInicioGestacao={medicoesPeso10SemanasAposInicioGestacao}
            dataInicioGestacao={dataInicioGestacao}
          />
        )}
      />
      <Route
        path={`${match.url}/altura-uterina`}
        render={() => (
          <GraficoAlturaUterinaView medicoesPreNatal={medicoesPreNatal} dataInicioGestacao={dataInicioGestacao} />
        )}
      />
    </PecSwitch>
  )
}
